const INITIAL_STATE = {
  data: {},
  errors: {},
  
}
const CloseFieldOffice = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'CLOSE_FIELD_OFFICE_SUCCESSFULLY':
    return { ...INITIAL_STATE, data: action.data }
  case 'CLOSE_FIELD_OFFICE_FAILED':
    return { ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};
  
export default CloseFieldOffice;